/* eslint-disable
    default-case,
    func-names,
    no-shadow,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');

const factory = function (GatewayApi, Model, PubnubActions) {
  let BenchEvent;
  return (BenchEvent = (function () {
    BenchEvent = class BenchEvent extends Model {
      static initClass() {
        this.prototype.personId = null;
        this.prototype.$idName = 'personId';
        this.prototype.$apiService = GatewayApi;

        this.prototype.$online = false;
      }
      $url() {
        return `notifications/bk/${this.id}`;
      }

      $count() {
        const previews = (this.events != null ? this.events.previews : undefined) || [];

        return _.reduce(previews, (count, preview) => count + preview.counter, 0);
      }

      $clear() {
        return this.$set({
          events: {
            previews: [],
          },
        });
      }

      $onMessage(e) {
        const events = _.cloneDeep(this.events);
        const i = _.findIndex(events.previews, { eventName: e.name });

        if (i > -1) {
          events.previews[i].counter += 1;
        } else {
          events.previews.push({
            eventName: e.name,
            counter: 1,
          });
        }

        return this.$set({ events });
      }

      $setPresence(res) {
        if (res.uuid === this.personId) {
          return (this.$online = (() => {
            switch (res.action) {
              case 'join':
                return true;
              case 'leave':
                return false;
            }
          })());
        }
      }

      $init(...args) {
        this.$subscribe(PubnubActions.messageCreated({ clientId: this.personId }), this.$onMessage);
        this.$subscribe(PubnubActions.presence({ clientId: this.personId }), this.$setPresence);
        return super.$init(...Array.from(args || []));
      }

      $fetch() {}
      $put() {}
      $delete() {}
      $post() {}
    };
    BenchEvent.initClass();
    return BenchEvent;
  })());
};

const moduleDeps = [require('data/util').name, require('data/actions/pubnub').name];

module.exports = angular
  .module('bench.data.model.benchEvent', moduleDeps)
  .factory('BenchEvent', factory);
